import styled from '@emotion/styled';
import React, { useState } from 'react';
import { CUSTOM_BREAK_POINT } from '../Block.styled';

type Props = {
  question: string;
  answer: string;
  index: number;
};

const FAQItem = ({ question, answer, index }: Props) => {
  const [isOpen, setIsOpen] = useState(false);

  const questionOnClick = () => {
    setIsOpen(!isOpen);
  };

  const SplitedAnswer = () => {
    if (!answer.includes('\n')) return <>{answer}</>;

    return answer.split('\n').map((v, idx) => (
      <React.Fragment key={String(idx)}>
        {v}
        <br />
      </React.Fragment>
    ));
  };

  return (
    <Wrapper>
      <Question.Wrapper isOpen={isOpen} onClick={questionOnClick}>
        <Question.ContentContainer>
          <Question.Index>Q{index + 1}</Question.Index>
          <Question.Content>{question}</Question.Content>
        </Question.ContentContainer>
        <div style={{ paddingRight: '3rem' }}>
          <Question.Cursor
            isOpen={isOpen}
            width='16'
            height='16'
            viewBox='0 0 16 16'
            fill='none'
            xmlns='http://www.w3.org/2000/svg'
          >
            <path
              d='M8.00001 11.0156C8.06598 11.0156 8.12848 11.0035 8.18751 10.9792C8.25001 10.9514 8.30383 10.9132 8.34897 10.8646L12.3802 6.73438C12.474 6.64062 12.5208 6.52951 12.5208 6.40104C12.5208 6.31076 12.5 6.22917 12.4583 6.15625C12.4167 6.08333 12.3594 6.02604 12.2865 5.98438C12.217 5.94271 12.1372 5.92188 12.0469 5.92188C11.9184 5.92188 11.8056 5.96701 11.7083 6.05729L7.71876 10.1354H8.27605L4.28647 6.05729C4.19272 5.96701 4.07987 5.92188 3.94793 5.92188C3.85765 5.92188 3.77605 5.94271 3.70314 5.98438C3.63369 6.02604 3.57814 6.08333 3.53647 6.15625C3.4948 6.22917 3.47397 6.31076 3.47397 6.40104C3.47397 6.46701 3.48612 6.52951 3.51043 6.58854C3.53473 6.6441 3.56945 6.69444 3.61459 6.73958L7.64584 10.8646C7.75001 10.9653 7.86807 11.0156 8.00001 11.0156Z'
              fill='white'
            />
          </Question.Cursor>
        </div>
      </Question.Wrapper>
      <AnswerWrapper isOpen={isOpen}>
        <Answer>{SplitedAnswer()}</Answer>
      </AnswerWrapper>
    </Wrapper>
  );
};

const Wrapper = styled.section`
  display: flex;
  flex-direction: column;
  align-items: center;
  padding-bottom: 48px;

  width: 100%;
  height: 100%;

  @media (max-width: ${CUSTOM_BREAK_POINT}px) {
    padding-bottom: 24px;
  }
`;

const Question = {
  Wrapper: styled.header<{ isOpen: boolean }>`
    cursor: pointer;
    display: flex;
    justify-content: space-between;
    align-items: center;
    background-color: transparent;
    color: white;
    border: 1px solid white;
    border-radius: 30rem;

    width: 100%;
    height: 100px;

    font-style: normal;
    font-size: 26px;

    @media (max-width: ${CUSTOM_BREAK_POINT}px) {
      font-size: 16px;
      height: 60px;
    }
  `,
  Cursor: styled.svg<{ isOpen: boolean }>`
    transform: ${(props) => (props.isOpen ? 'rotate(180deg)' : 'rotate(0deg)')};
    transition: all 0.5s;
    scale: calc(1.5);
  `,
  ContentContainer: styled.div`
    display: flex;
    padding-left: 3rem;
  `,
  Index: styled.span`
    display: flex;
    align-items: center;
    font-weight: 600;
  `,
  Content: styled.span`
    margin-left: 37px;
  `,
};

const AnswerWrapper = styled.div<{ isOpen: boolean }>`
  display: flex;
  width: 100%;
  flex-wrap: nowrap;
  overflow: hidden;
  font-size: 1rem;
  font-style: normal;
  font-weight: 400;
  word-break: keep-all;
  color: rgba(235, 235, 245, 1);

  height: ${(props) => (props.isOpen ? '152px' : '0px')};
  opacity: ${(props) => (props.isOpen ? 1 : 0)};

  transition: all 0.3s;
`;

const Answer = styled.p`
  line-height: 38px;
  padding-top: 31px;
  padding-left: 119px;
  font-size: 26px;
  font-weight: 400;

  @media (max-width: ${CUSTOM_BREAK_POINT}px) {
    font-size: 16px;
    padding-top: 16px;
    padding-left: 60px;
  }
`;

export default FAQItem;
